import _ from 'lodash';
import { useRouter } from 'next/router';
import React from 'react';

import MaxWidthContainer from 'components/MaxWidthContainer';
import classnames from 'classnames';

import useSWR from 'swr';

import { ChevronLeftSvg } from 'components/SorraSvg';
import { ranks } from 'utils/voting2024';
import { swrFetcher } from 'utils/api';
import { useAppLaunch } from 'contexts/AppLaunch';
// import useRWD from 'hooks/useRWD';

const { useState, useEffect, useRef, forwardRef } = React;

const factorKeys = [
  'overall',
  'neutral',
  'dry',
  'oily',
  'combination',
  'sensitive',
];
const factorNameMap = {
  overall: '全肌質',
  neutral: '中性肌',
  dry: '乾性肌',
  oily: '油性肌',
  combination: '混合肌',
  sensitive: '敏感肌',
};

const ProductCard = (props) => {
  const router = useRouter();
  const { idx, rankKey, productId } = props;
  const { factorMap, productOriginMap } = useAppLaunch();
  const { data: product } = useSWR(
    `/api/v2/product/${productId}/overview`,
    swrFetcher
  );
  // const { productName, brandName } = props;
  const facts = _.get(product, 'facts', []);

  const origin = _.get(product, 'origin');
  const image = _.get(product, 'images[0].url', '');
  const brandName = _.get(product, 'brand.name', '');
  const productName = _.get(product, 'name', '');
  const review = _.get(product, 'reviews.0', []);
  const reviews = _.take(_.get(product, 'reviews', []), 2);
  const factors = _.get(review, 'factors', []);
  const factorNames = _.map(factors, (factor) => {
    return factorMap[factor] ? factorMap[factor].name : '';
  });

  const productOrigin = productOriginMap[origin];
  // console.log({ factors });
  // console.log({ factorNames });
  // console.log({ image });
  // console.log({ product });
  return (
    <>
      {/* desktop */}
      <div
        style={{
          filter: 'drop-shadow(3px 3px 9.6px rgba(0, 0, 0, 0.10))',
          height: idx < 3 ? '274px' : '217px',
        }}
        className="relative hidden w-full shrink-0 cursor-pointer gap-x-3 rounded-xl bg-white py-4 pl-[50px] pr-8 lg:flex"
        onClick={() => {
          router.push(`/product/${productId}`);
        }}
      >
        <div className="relative h-full w-[190px] shrink-0">
          <img
            src={image ? image : '/images/placeholders/product.png'}
            className="h-full w-full object-contain object-bottom"
          />
          <img
            className="absolute -bottom-0 -left-[18px] aspect-[72/63] w-[37%] object-contain"
            src={`/images/2024/result/categories/${rankKey}/Rank${idx < 3 ? idx + 1 : '4-10'}.png`}
          />
        </div>
        <div className="flex min-w-0 grow flex-col justify-center">
          <p className="shrink-0 truncate text-base text-[#4A4A4A]">
            {brandName}
          </p>
          <p className="shrink-0 truncate text-2xl font-medium text-[#111928]">
            {productName}
          </p>
          <div className="mt-3 flex w-full gap-x-2 text-base font-medium">
            {productOrigin && (
              <div
                style={{
                  background: 'rgba(252, 225, 229, 0.5)',
                }}
                className="rounded-md px-2 py-1 text-[#f16b7c]"
              >
                {productOrigin.name}
              </div>
            )}
            {facts.map((fact) => {
              const { name, bg_color, text_color } = fact;
              return (
                <div
                  key={name}
                  style={{
                    background: bg_color || 'rgba(252, 225, 229, 0.5)',
                    color: text_color || '#f16b7c',
                  }}
                  className="rounded-md px-2 py-1 text-[#f16b7c]"
                >
                  {name}
                </div>
              );
            })}
          </div>
          {!_.isEmpty(reviews) && (
            <div className="mt-3 flex w-full flex-col gap-y-2">
              {_.take(reviews, idx < 3 ? 2 : 1).map((review) => {
                const { id, sorra_user, mask_name } = review;

                const avatarUrl = _.get(sorra_user, 'picture', '');
                return (
                  <div
                    key={id}
                    className="flex h-13 w-full flex-row items-center gap-x-3 overflow-hidden rounded-2xl bg-[#F5F5F5] px-4"
                  >
                    <div className="h-7 w-7 shrink-0 overflow-hidden rounded-full bg-[#D6DDFB]">
                      {!_.isEmpty(avatarUrl) ? (
                        <img
                          src={avatarUrl}
                          className="h-full w-full object-cover"
                        />
                      ) : (
                        mask_name && (
                          <div className="flex h-full w-full items-center justify-center">
                            <p className="text-xs font-medium text-[#5882FF]">
                              {_.upperCase(mask_name[0])}
                            </p>
                          </div>
                        )
                      )}
                    </div>
                    <div className="min-w-0 grow truncate text-base font-normal">
                      {review.comment || ''}
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div
          style={{
            width: '72px',
            height: '72px',
          }}
          className="absolute -left-[3px] -top-[3px]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 68 68"
            fill="none"
          >
            <path
              d="M5.12132 66.8787C3.23143 68.7686 8.02891e-06 67.4301 8.26257e-06 64.7574L6.03216e-06 3.00015C6.177e-06 1.3433 1.34315 0.00015404 3 0.000146556L64.7573 1.46256e-05C67.4301 1.48593e-05 68.7686 3.23144 66.8787 5.12134L36 36L5.12132 66.8787Z"
              fill={
                idx == 0
                  ? '#FABE3D'
                  : idx == 1
                    ? '#C6C6C6'
                    : idx == 2
                      ? '#E49546'
                      : '#F16B7C'
              }
            />
          </svg>
          <div className="absolute left-[5px] top-[5px] flex flex-row items-end font-rubik">
            <div className="flex flex-col items-center">
              <img
                style={{
                  width: '13px',
                  height: '10px',
                }}
                src="/images/2024/result/mobile/crown.png"
                className="object-contain"
              />
              <p
                style={{
                  fontSize: idx < 9 ? '24px' : '20px',
                }}
                className="font-medium text-white"
              >
                {idx + 1}
              </p>
            </div>
            <p
              style={{
                paddingBottom: '7px',
                marginLeft: '1px',
              }}
              className="text-[8px] font-semibold text-white"
            >
              位
            </p>
          </div>
        </div>
      </div>
      {/* mobile */}
      <div
        style={{
          filter: 'drop-shadow(3px 3px 9.6px rgba(0, 0, 0, 0.10))',
          height: idx < 3 ? '200px' : '75px',
        }}
        className={classnames(
          'relative flex w-full shrink-0 gap-x-3 rounded-xl bg-white lg:hidden',
          {
            'px-5 py-6': idx < 3,
            'px-10 py-3': idx >= 3,
          }
        )}
        onClick={() => {
          router.push(`/product/${productId}`);
        }}
      >
        <div className="relative aspect-[126/139] h-full shrink-0">
          <img
            src={image ? image : '/images/placeholders/product.png'}
            className="h-full w-full object-contain object-bottom"
          />
          {idx < 3 && (
            <img
              className="absolute -bottom-2 -left-2 h-[41px] w-[47px] object-contain"
              src={`/images/2024/result/categories/${rankKey}/Rank${idx + 1}.png`}
            />
          )}
        </div>
        <div className="flex min-w-0 grow flex-col justify-center gap-y-1.5">
          <p className="truncate text-sm text-[#4A4A4A]">{brandName}</p>
          <p className="truncate text-[15px] font-medium text-[#111928]">
            {productName}
          </p>
          <div className="mt-0.5 min-h-0 grow text-sm text-[#111928]">
            {idx < 3 && !_.isEmpty(review) && (
              <div className="flex h-full flex-col justify-between rounded-lg bg-[#F5F5F5] px-3 py-3">
                <div className="line-clamp-2 w-full font-normal">
                  {review.comment}
                </div>
                <p className="truncate text-right text-[8px] font-bold">
                  {`${review.mask_name} | ${factorNames.join(',')}`}
                </p>
              </div>
            )}
          </div>
        </div>
        <div
          style={{
            width: idx < 3 ? '72px' : '54px',
            height: idx < 3 ? '72px' : '54px',
          }}
          className="absolute -left-[3px] -top-[3px]"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 68 68"
            fill="none"
          >
            <path
              d="M5.12132 66.8787C3.23143 68.7686 8.02891e-06 67.4301 8.26257e-06 64.7574L6.03216e-06 3.00015C6.177e-06 1.3433 1.34315 0.00015404 3 0.000146556L64.7573 1.46256e-05C67.4301 1.48593e-05 68.7686 3.23144 66.8787 5.12134L36 36L5.12132 66.8787Z"
              fill={
                idx == 0
                  ? '#FABE3D'
                  : idx == 1
                    ? '#C6C6C6'
                    : idx == 2
                      ? '#E49546'
                      : '#F16B7C'
              }
            />
          </svg>
          <div className="absolute left-[5px] top-[5px] flex flex-row items-end font-rubik">
            <div className="flex flex-col items-center">
              <img
                style={{
                  width: idx < 3 ? '13px' : '10px',
                  height: idx < 3 ? '10px' : '8px',
                }}
                src="/images/2024/result/mobile/crown.png"
                className="object-contain"
              />
              <p
                style={{
                  fontSize: idx < 3 ? '24px' : idx < 9 ? '16px' : '13px',
                }}
                className="font-medium text-white"
              >
                {idx + 1}
              </p>
            </div>
            <p
              style={{
                paddingBottom: idx < 3 ? '7px' : idx < 9 ? '4px' : '3px',
                marginLeft: idx < 3 ? '1px' : '1px',
              }}
              className="text-[8px] font-semibold text-white"
            >
              位
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

// const [featureFirst, setFeatureFirst] = useState(0);

const BeautyAwards2024ResultRanking = (props) => {
  const router = useRouter();

  const rankItemsRef = useRef(null);

  const [isCollapse, setCollapse] = useState(false);
  const [currentRankIdx, setCurrentRankIdx] = useState(0);
  const [currentFactor, setCurrentFactor] = useState(factorKeys[0]);
  const rankKey = ranks[currentRankIdx].key;

  const targetProducts = ranks[currentRankIdx].factor[currentFactor];
  // const productIds = targetProducts.map((product) => product.id);
  const scrollerRef = useRef(null);

  useEffect(() => {
    const hash = window.location.hash;
    if (!_.isEmpty(hash)) {
      const hashKey = hash.replace('#', '');
      const rankIdx = _.findIndex(ranks, { key: hashKey });
      if (rankIdx !== -1) {
        setCurrentRankIdx(rankIdx);
        if (rankItemsRef.current) {
          rankItemsRef.current.children[rankIdx].scrollIntoView({
            behavior: 'smooth',
            inline: 'center',
          });
        }
      }
    }
  }, []);

  // const
  return (
    <div className="flex h-dvh w-full flex-col overflow-hidden bg-sorra-pink bg-opacity-5 lg:h-auto">
      <div className="relative block h-[120px] w-full shrink-0 bg-sorra-pink pt-8 lg:hidden">
        <div className="relative flex items-center justify-center text-[20px] font-bold text-white">
          <p>功能排名榜</p>
          <div
            className="absolute left-6 top-1/2 flex -translate-y-1/2 cursor-pointer items-center py-4 text-xs font-normal text-white"
            onClick={() => {
              router.back();
            }}
          >
            <div className="h-4 w-4">
              <ChevronLeftSvg color="white" />
            </div>
            <p>返回</p>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 w-full">
          <div
            ref={rankItemsRef}
            className="no-scrollbar flex w-full flex-row gap-x-6 overflow-x-auto overflow-y-hidden px-6 text-[15px] text-white"
          >
            {ranks.map((rank, idx) => {
              const { key, name } = rank;
              const selected = idx === currentRankIdx;
              return (
                <div
                  key={key}
                  className={classnames(
                    'flex shrink-0 cursor-pointer flex-col items-center',
                    {
                      'font-normal opacity-70': !selected,
                      'font-bold opacity-100': selected,
                    }
                  )}
                  onClick={() => {
                    setCurrentRankIdx(idx);
                    scrollerRef.current.scrollTo(0, 0, { behavior: 'smooth' });
                  }}
                >
                  <p className="">{name}</p>
                  <div
                    className={classnames(
                      'h-5 w-5 translate-y-1/2 -rotate-45 rounded-tr-md bg-white',
                      {
                        hidden: !selected,
                      }
                    )}
                  >
                    <div className="h-full w-full bg-sorra-pink bg-opacity-5" />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="block lg:hidden">
        <div className="no-scrollbar flex gap-x-2 overflow-y-hidden overflow-x-scroll p-4 text-xs font-bold text-sorra-pink">
          {factorKeys.map((factorKey, idx) => {
            const selected = factorKey === currentFactor;
            return (
              <div
                key={factorKey}
                className={classnames(
                  'shrink-0 rounded-full border border-sorra-pink px-3 py-1.5',
                  {
                    'bg-sorra-pink text-white': selected,
                    'text-sorra-pink': !selected,
                  }
                )}
                onClick={() => {
                  setCurrentFactor(factorKey);
                  scrollerRef.current.scrollTo(0, 0, { behavior: 'smooth' });
                }}
              >
                {factorNameMap[factorKey]}
              </div>
            );
          })}
        </div>
      </div>
      <MaxWidthContainer className="relative hidden h-[224px] items-center justify-between px-[110px] py-13 lg:flex">
        <div className="h-[120px] w-[136px]">
          <img src={`/images/2024/result/mobile/rank_general.png`} />
        </div>
        <div className="-translate-x absolute left-1/2 top-1/2 flex -translate-x-1/2 -translate-y-1/2 items-start gap-x-7 text-[18px] font-semibold">
          <div className="cursor-pointer border-b-[1.5px] border-sorra-pink pb-1.5 text-sorra-pink">
            功能排行
          </div>
          <div
            className="cursor-pointer"
            onClick={() => {
              router.push('/beautyawards2024/result/trend');
            }}
          >
            TOP 10美妝趨勢
          </div>
        </div>
        <div
          className="flex cursor-pointer items-center gap-x-3 rounded-full bg-sorra-pink px-6 py-3"
          onClick={() => {
            router.push('/');
          }}
        >
          <p className="text-white">前往SORRA主頁 </p>
          <div className="h-3 w-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M0.292893 12.2929C-0.0976311 12.6834 -0.0976311 13.3166 0.292893 13.7071C0.683418 14.0976 1.31658 14.0976 1.70711 13.7071L0.292893 12.2929ZM14 0.999999C14 0.447714 13.5523 -8.61581e-07 13 -1.11446e-06L4 -3.13672e-07C3.44772 -6.50847e-07 3 0.447715 3 0.999999C3 1.55228 3.44772 2 4 2L12 2L12 10C12 10.5523 12.4477 11 13 11C13.5523 11 14 10.5523 14 10L14 0.999999ZM1.70711 13.7071L13.7071 1.70711L12.2929 0.292893L0.292893 12.2929L1.70711 13.7071Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </MaxWidthContainer>
      <div className="border-b border-[#E7E7E7]">
        <MaxWidthContainer className="hidden lg:block">
          <p className="text-5xl font-bold">功能排名榜</p>
          <div className="mt-8 flex justify-start gap-x-10">
            {ranks.map((rank, idx) => {
              const { key, name } = rank;
              const selected = idx === currentRankIdx;
              return (
                <div
                  key={key}
                  className={classnames(
                    'flex shrink-0 cursor-pointer flex-col items-center',
                    {
                      'font-normal opacity-70': !selected,
                      'font-bold opacity-100': selected,
                    }
                  )}
                  onClick={() => {
                    setCurrentRankIdx(idx);
                    scrollerRef.current.scrollTo(0, 0, { behavior: 'smooth' });
                  }}
                >
                  <p className="">{name}</p>
                  <div
                    className={classnames(
                      'mt-4 h-[3px] w-full rounded-full bg-sorra-pink',
                      {
                        hidden: !selected,
                      }
                    )}
                  />
                </div>
              );
            })}
          </div>
        </MaxWidthContainer>
      </div>
      <MaxWidthContainer className="no-scrollbar block min-h-0 grow items-start gap-x-12 overflow-y-auto pt-0 lg:flex lg:grow-0 lg:pt-9">
        <div className="hidden w-[268px] shrink-0 border-b border-[#D1D5DB] pb-4 lg:block">
          <div className="flex items-center justify-between">
            <p className="text-base font-bold text-[#111928]">膚質</p>
            <img
              className="cursor-pointer"
              src={
                isCollapse
                  ? '/svgs/index-section-expand.svg'
                  : '/svgs/index-section-collapse.svg'
              }
              onClick={() => {
                setCollapse(!isCollapse);
              }}
            ></img>
          </div>
          {!isCollapse && (
            <div className="mt-3 flex flex-col items-start gap-y-2.5 text-base font-bold">
              {factorKeys.map((factorKey, idx) => {
                const selected = factorKey === currentFactor;
                return (
                  <div
                    key={factorKey}
                    className={classnames(
                      'shrink-0 cursor-pointer rounded-full border border-sorra-pink px-4 py-2',
                      {
                        'bg-sorra-pink text-white': selected,
                        'text-sorra-pink': !selected,
                      }
                    )}
                    onClick={() => {
                      setCurrentFactor(factorKey);
                      scrollerRef.current.scrollTo(0, 0, {
                        behavior: 'smooth',
                      });
                    }}
                  >
                    {factorNameMap[factorKey]}
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div
          ref={scrollerRef}
          className="flex min-w-0 grow flex-col items-center gap-y-5 px-4 pb-11 pt-2"
        >
          {targetProducts.map((product, idx) => {
            const { productId: id } = product;
            return (
              <ProductCard key={id} idx={idx} rankKey={rankKey} {...product} />
            );
          })}
        </div>
        <div className="flex justify-center pb-13 lg:hidden">
          <div
            className="flex cursor-pointer items-center gap-x-3 rounded-full bg-sorra-pink px-6 py-3"
            onClick={() => {
              router.back();
            }}
          >
            <div className="h-4 w-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 22 20"
                fill="none"
              >
                <path
                  d="M20.8867 11.1543C21.439 11.1543 21.8867 10.7066 21.8867 10.1543C21.8867 9.60201 21.439 9.1543 20.8867 9.1543V11.1543ZM0.598203 9.44719C0.207679 9.83771 0.207679 10.4709 0.598203 10.8614L6.96216 17.2254C7.35269 17.6159 7.98585 17.6159 8.37638 17.2254C8.7669 16.8348 8.7669 16.2017 8.37638 15.8112L2.71952 10.1543L8.37638 4.49744C8.7669 4.10692 8.7669 3.47375 8.37638 3.08323C7.98585 2.69271 7.35269 2.69271 6.96216 3.08323L0.598203 9.44719ZM20.8867 9.1543H1.30531V11.1543H20.8867V9.1543Z"
                  fill="white"
                />
              </svg>
            </div>
            <p className="text-white"> 回到上一頁</p>
          </div>
        </div>
      </MaxWidthContainer>
      <MaxWidthContainer className="hidden justify-center pb-13 lg:flex">
        <div
          className="flex cursor-pointer items-center gap-x-3 rounded-full bg-sorra-pink px-6 py-3"
          onClick={() => {
            router.back();
          }}
        >
          <div className="h-4 w-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 22 20"
              fill="none"
            >
              <path
                d="M20.8867 11.1543C21.439 11.1543 21.8867 10.7066 21.8867 10.1543C21.8867 9.60201 21.439 9.1543 20.8867 9.1543V11.1543ZM0.598203 9.44719C0.207679 9.83771 0.207679 10.4709 0.598203 10.8614L6.96216 17.2254C7.35269 17.6159 7.98585 17.6159 8.37638 17.2254C8.7669 16.8348 8.7669 16.2017 8.37638 15.8112L2.71952 10.1543L8.37638 4.49744C8.7669 4.10692 8.7669 3.47375 8.37638 3.08323C7.98585 2.69271 7.35269 2.69271 6.96216 3.08323L0.598203 9.44719ZM20.8867 9.1543H1.30531V11.1543H20.8867V9.1543Z"
                fill="white"
              />
            </svg>
          </div>
          <p className="text-white"> 回到上一頁</p>
        </div>
      </MaxWidthContainer>
    </div>
  );
};

export default BeautyAwards2024ResultRanking;

// export async function getServerSideProps(ctx) {
//   const { key } = ctx.query;
//   try {
//     const { data: campaigns } = await api.request({
//       method: 'GET',
//       url: `/api/v3/campaigns`,
//     });
//     const targetCampaign = _.find(campaigns, { name: 'BEAUTY_AWARD_2024' });
//     if (targetCampaign || key === 'F5A3302A-E6AB-44E7-ABEB-D41DECD1DCAA') {
//       return {
//         props: {},
//       };
//     } else {
//       return {
//         props: {
//           expired: true,
//         },
//       };
//     }
//   } catch (e) {
//     console.log(e);
//   }
//   return {
//     notFound: true,
//   };
// }
